



































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import TrashIcon from '@/app/ui/assets/trash_icon_alt.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import DropdownButton from '../../components/DropdownButton/index.vue'
import ModalConfirm from '../../components/Modals/ModalConfirm/index.vue'
import controller from '@/app/ui/controllers/ManageCourierDedicatedController'
import Badge from '@/app/ui/components/Badge/index.vue'
import {
  IDataCell,
  IHeaderCell,
  IOptions,
  IParams,
  listStatusOptions,
  ManageCourierDedicatedStatus,
  offerMethodOptions,
  sortOptions,
} from '@/app/infrastructures/misc/Constants/manageCourierDedicated'
import { Utils } from '@/app/infrastructures/misc'
import {
  CourierDedicated,
  DedicatedData,
  GeoAddress,
} from '@/domain/entities/ManageCourierDedicated'
import { Location } from 'vue-router'
import ManageCourierController from '@/app/ui/controllers/ManageCourierController'
import { ShowCourierPhoneRequest } from '@/data/payload/api/ManageCourierRequest'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'

interface ILocation {
  id: number
  name: string
  children: Array<ILocation>
  isSelected: () => boolean
}

interface IGeoAddress {
  id: number
  name: string
  children: Array<IGeoAddress>
}

interface IManageCourierDedicated {
  areaId: number
  areaName: string
  geoAddress: Array<ILocation>
  courierMp: Array<CourierDedicated>
  courierCa: Array<CourierDedicated>
  courierClient: Array<CourierDedicated>
  offerType: string
  isActive: boolean
  updatedAt: string
  createdAt: string
}

interface IManageDedicatedV2 {
  areaId: number
  areaName: string
  geoAddress: Array<ILocation>
  dedicatedMp: Array<DedicatedData>
  dedicatedCa: Array<DedicatedData>
  dedicatedClient: Array<DedicatedData>
  dedicatedCorporateCar: Array<DedicatedData>
  dedicatedCorporateMotorcycle: Array<DedicatedData>
  offerType: string
  isActive: boolean
  updatedAt: string
  createdAt: string
}

@Component({
  components: {
    Badge,
    Button,
    TextInput,
    TrashIcon,
    DataTableV2,
    PaginationNav,
    DropdownSelect,
    DropdownButton,
    ModalConfirm,
    LoadingOverlay,
    EyeIcon,
    EyeDisabledIcon,
  },
})
class AreaDedicatedListPage extends Vue {
  controller = controller
  isDropdownButtonVisible = false
  modalConfirmVisible = false
  deleteId = ''

  statusOptions: Array<IOptions> = listStatusOptions
  offerOptions: Array<IOptions> = offerMethodOptions
  sortOptions: Array<IOptions> = sortOptions
  geoAddressData: Array<GeoAddress> = []
  countDedicatedPosMp: Array<number> = []
  countDedicatedCourierMp: Array<number>  = []
  countDedicatedPosCa: Array<number>  = []
  countDedicatedCourierCa: Array<number>  = []
  countDedicatedPosClient: Array<number>  = []
  countDedicatedPosCorporateCar: Array<number>  = []
  countDedicatedPosCorporateMotorcycle: Array<number>  = []
  countDedicatedCourierClient: Array<number>  = []
  countDedicatedCourierCorporateCar: Array<number>  = []
  countDedicatedCourierCorporateMotorcycle: Array<number>  = []
  isSpecialHandlingCorporateCar: Array<boolean> = []
  isSpecialHandlingCorporateMotorcycle: Array<boolean> = []

  visiblePhones: Record<string, string> = {}

  dedicatedDataByRow: Array<{
    dedicatedMp: DedicatedData[]
    dedicatedCa: DedicatedData[]
    dedicatedClient: DedicatedData[]
    dedicatedCorporateCar: DedicatedData[]
    dedicatedCorporateMotorcycle: DedicatedData[]
  }> = []

  parameters: IParams = {
    page: 1,
    per_page: 10,
    status: this.statusOptions[0],
    offer: this.offerOptions[0],
    sort: this.sortOptions[0],
    keyword: '',
  }

  geoAddressParameters: Record<string, string> = {
    search: '',
  }

  headers: Array<string | IHeaderCell> = [
    this.headerCellMapper('No.', '50px'),
    this.headerCellMapper('Area', '160px'),
    this.headerCellMapper('Wilayah', '300px'),
    this.headerCellMapper('Dedicated Marketplace', '240px'),
    this.headerCellMapper('Dedicated Customer', '240px'),
    this.headerCellMapper('Dedicated Client', '240px'),
    this.headerCellMapper('Dedicated Corporate Mobil', '300px'),
    this.headerCellMapper('Dedicated Corporate Motor', '300px'),
    this.headerCellMapper('Metode Penawaran', '180px'),
    this.headerCellMapper('Status', '140px'),
    this.headerCellMapper('Terakhir Diubah', '180px'),
    this.headerCellMapper('Dibuat Tanggal', '180px'),
    this.headerCellMapper('Aksi', '400px'),
  ]

  manageCourierDedicatedData: Array<
    Array<string | Array<string> | IDataCell>
  > = []

  created(): void {
    this.fetchGeoAddress()
  }

  get params(): Record<string, string | number> {
    return {
      page: this.parameters.page,
      per_page: this.parameters.per_page,
      keyword: this.parameters.keyword,
      status: <string>this.parameters.status.value,
      offer_type: <string>this.parameters.offer.value,
      sort_by: <string>this.parameters.sort.value,
    }
  }

  get geoAddressParams(): Record<string, string> {
    return this.geoAddressParameters
  }

  private fetchManageCourierDedicated(reset?: boolean): void {
    if (reset) this.parameters.page = 1
    this.visiblePhones = {};
    controller.getAllV2(this.params)
  }

  private fetchGeoAddress(): void {
    controller.getGeoAddress(this.geoAddressParams)
  }

  private setBadgeStyle(status: string): string {
    if (status.toUpperCase() === ManageCourierDedicatedStatus.AKTIF) {
      return 'success'
    }

    return 'error'
  }

  private routeTo(id: string, routeName: string): Location {
    return {
      name: routeName,
      params: { id: id }
    }
  }

  private onConfirmDelete(id: string): void {
    this.deleteId = id
    this.modalConfirmVisible = true
  }

  private onCancelDelete(): void {
    this.deleteId = ''
    this.modalConfirmVisible = false
  }

  private onDelete(): void {
    this.modalConfirmVisible = false

    if (this.deleteId) {
      controller.deleteManageCourierDedicatedV2(Number(this.deleteId))
    }
  }

  private onSearchFilter(): void {
    if (
      (this.parameters.keyword && this.parameters.keyword.length > 2) ||
      !this.parameters.keyword
    ) {
      this.onFilterList()
    }
  }

  private onFilterList = Utils.debounce(() => {
    this.fetchManageCourierDedicated(true)
  }, 500)

  private tableCellMapper(
    value: string | number | boolean | string[],
    colWidth: string,
  ): IDataCell {
    return {
      value: value,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
    }
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string
  ): IHeaderCell {
    return {
      title: title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
    }
  }

  private setCourierData(courierList: Array<CourierDedicated>): Array<string> {
    return courierList.map(courier => {
      return `[${courier.courierId}] ${courier.name} (${courier.courierType}) ${courier.phone}`
    })
  }

  private setDedicatedData(
    dedicatedList: Array<DedicatedData>,
    rowIndex: number,
    columnType: 'mp' | 'ca' | 'corporate' | 'corporate_car' | 'corporate_motorcycle'
  ): Array<string> {
    return dedicatedList.map(dedicated => {
      if (dedicated.assignee === 'COURIER') {
        const key = `${rowIndex}-${columnType}-${dedicated.id}`
        const phone = this.visiblePhones[key] || '********'
        return `[${dedicated.id}] ${dedicated.name} (${dedicated.courierType}) ${phone}`
      }
      return `[${dedicated.posCode}] ${dedicated.posName}`
    })
  }

  private getDedicatedList(
    rowIndex: number,
    columnType: 'mp' | 'ca' | 'corporate' | 'corporate_car' | 'corporate_motorcycle'
  ): DedicatedData[] {
    const row = this.dedicatedDataByRow[rowIndex]
    if (!row) return []

    const map = {
      mp: row.dedicatedMp,
      ca: row.dedicatedCa,
      corporate: row.dedicatedClient,
      corporate_car: row.dedicatedCorporateCar,
      corporate_motorcycle: row.dedicatedCorporateMotorcycle,
    }

    return map[columnType] || []
  }

  private isFirstItemCourier(
    rowIndex: number,
    columnType: 'mp' | 'ca' | 'corporate' | 'corporate_car' | 'corporate_motorcycle'
  ): boolean {
    const list = this.getDedicatedList(rowIndex, columnType)
    return list[0]?.assignee === 'COURIER'
  }

  private isPhoneVisible(
    rowIndex: number,
    columnType: 'mp' | 'ca' | 'corporate' | 'corporate_car' | 'corporate_motorcycle'
  ): boolean {
    const list = this.getDedicatedList(rowIndex, columnType)
    const first = list[0]
    if (!first || first.assignee !== 'COURIER') return false

    const key = `${rowIndex}-${columnType}-${first.id}`
    return Boolean(this.visiblePhones[key])
  }

  private async togglePhone(
    rowIndex: number,
    columnType: 'mp' | 'ca' | 'corporate' | 'corporate_car' | 'corporate_motorcycle'
  ): Promise<void> {
    const list = this.getDedicatedList(rowIndex, columnType)
    const first = list[0]
    if (!first || first.assignee !== 'COURIER') return

    const key = `${rowIndex}-${columnType}-${first.id}`
    const colIndexMap: Record<string, number> = { mp: 3, ca: 4, corporate: 5, corporate_car: 6, corporate_motorcycle: 7 }
    const ci = colIndexMap[columnType]

    if (this.visiblePhones[key]) {
      this.$delete(this.visiblePhones, key)
      const newLabels = this.setDedicatedData(list, rowIndex, columnType)
      this.$set(this.manageCourierDedicatedData[rowIndex][ci] as IDataCell, 'value', newLabels)
      return
    }

    const phone = await ManageCourierController.showCourierPhone(
      new ShowCourierPhoneRequest({
        id: first.id,
        source: 'dedicated-area-list',
        type: columnType,
      })
    )

    if (phone) {
      this.$set(this.visiblePhones, key, phone)
      const newLabels = this.setDedicatedData(list, rowIndex, columnType)
      this.$set(this.manageCourierDedicatedData[rowIndex][ci] as IDataCell, 'value', newLabels)
    }
  }

  private locationMapper(
    data: GeoAddress,
    selectedIds: Array<number>
  ): ILocation {
    return {
      id: data.geoAddressId || NaN,
      name: data.name || '',
      children: data.children
        ? data.children.map(child => {
            return this.locationMapper(child, selectedIds)
          })
        : [],
      isSelected(): boolean {
        if (
          data.geoAddressId &&
          selectedIds.includes(Number(data.geoAddressId))
        ) {
          return true
        }

        return false
      },
    }
  }

  private getName(data: Array<ILocation>): Array<string> {
    let nameList: Array<string> = []

    data.forEach(item => {
      if (item.isSelected()) {
        nameList.push(item.name)
      } else {
        nameList.push(...this.getName(item.children))
      }
    })

    return nameList
  }

  private countRemainingCourier(data: any) {
    return data.splice(0, 1).filter((item: any) => item.assignee === "COURIER").length
  }

  private countRemainingPos(data: any) {
    return data.splice(0, 1).filter((item: any) => item.assignee === "POS").length
  }

  private setBadgeLabel(isActive: boolean): string {
    return isActive ? "Aktif" : "Nonaktif"
  }

  private resetCounter() {
    this.countDedicatedPosMp = []
    this.countDedicatedCourierMp  = []
    this.countDedicatedPosCa = []
    this.countDedicatedCourierCa = []
    this.countDedicatedPosClient = []
    this.countDedicatedCourierClient = []
    this.countDedicatedCourierCorporateCar = [];
    this.countDedicatedCourierCorporateMotorcycle = [];
    this.countDedicatedPosCorporateMotorcycle = [];
    this.countDedicatedPosCorporateCar = [];
    this.isSpecialHandlingCorporateMotorcycle = [];
    this.isSpecialHandlingCorporateCar = [];
  }

  @Watch('controller.dataManageDedicatedListV2')
  setManageCourierDedicatedData(data: IManageDedicatedV2[]): void {
    this.resetCounter()
    this.manageCourierDedicatedData = data.map((item, index) => {
      let locationNames: Array<string> = []

      if (item.geoAddress) {
        let locationIds: Array<number> = []

        item.geoAddress.forEach(location => {
          if (location.id) {
            locationIds.push(location.id)
          }
        })

        if (locationIds.length !== 0) {
          const locData = this.geoAddressData.map(location => {
            return this.locationMapper(location, locationIds)
          })

          locationNames = this.getName(locData)
        }
      }

      const countMP = [...item.dedicatedMp].slice(1)
      this.countDedicatedPosMp.push(countMP.filter((item: DedicatedData) => item.assignee === "POS").length || 0);
      this.countDedicatedCourierMp.push(countMP.filter((item: DedicatedData) => item.assignee === "COURIER").length || 0);

      const countCA = [...item.dedicatedCa].slice(1)
      this.countDedicatedPosCa.push(countCA.filter((item: DedicatedData) => item.assignee === "POS").length || 0);
      this.countDedicatedCourierCa.push(countCA.filter((item: DedicatedData) => item.assignee === "COURIER").length || 0);

      const countClient = [...item.dedicatedClient].slice(1)
      this.countDedicatedPosClient.push(countClient.filter((item: DedicatedData) => item.assignee === "POS").length || 0);
      this.countDedicatedCourierClient.push(countClient.filter((item: DedicatedData) => item.assignee === "COURIER").length || 0);

      const countCorporateCar = [...item.dedicatedCorporateCar].slice(1)
      this.countDedicatedPosCorporateCar.push(countCorporateCar.filter((item: DedicatedData) => item.assignee === "POS").length || 0);
      this.countDedicatedCourierCorporateCar.push(countCorporateCar.filter((item: DedicatedData) => item.assignee === "COURIER").length || 0);
      this.isSpecialHandlingCorporateCar.push(item.dedicatedCorporateCar.some((item: DedicatedData) => item.isSpecialHandling))

      const countCorporateMotorcycle = [...item.dedicatedCorporateMotorcycle].slice(1)
      this.countDedicatedPosCorporateMotorcycle.push(countCorporateMotorcycle.filter((item: DedicatedData) => item.assignee === "POS").length || 0);
      this.countDedicatedCourierCorporateMotorcycle.push(countCorporateMotorcycle.filter((item: DedicatedData) => item.assignee === "COURIER").length || 0);
      this.isSpecialHandlingCorporateMotorcycle.push(item.dedicatedCorporateMotorcycle.some((item: DedicatedData) => item.isSpecialHandling))

      this.dedicatedDataByRow[index] = {
        dedicatedMp: item.dedicatedMp || [],
        dedicatedCa: item.dedicatedCa || [],
        dedicatedClient: item.dedicatedClient || [],
        dedicatedCorporateCar: item.dedicatedCorporateCar || [],
        dedicatedCorporateMotorcycle: item.dedicatedCorporateMotorcycle || [],
      }

      return [
        this.tableCellMapper(
          (this.parameters.page - 1) * this.parameters.per_page + index + 1,
          '50px'
        ),
        this.tableCellMapper(item.areaName || '-', '160px'),
        this.tableCellMapper(
          JSON.stringify(locationNames),
          '300px'
        ),
        this.tableCellMapper(item.dedicatedMp ? this.setDedicatedData(item.dedicatedMp, index, 'mp') : [], '240px'),
        this.tableCellMapper(item.dedicatedCa ? this.setDedicatedData(item.dedicatedCa, index, 'ca') : [], '240px'),
        this.tableCellMapper(item.dedicatedClient ? this.setDedicatedData(item.dedicatedClient, index, 'corporate') : [], '240px'),
        this.tableCellMapper(item.dedicatedCorporateCar ? this.setDedicatedData(item.dedicatedCorporateCar, index, 'corporate_car') : [], '300px'),
        this.tableCellMapper(item.dedicatedCorporateMotorcycle ? this.setDedicatedData(item.dedicatedCorporateMotorcycle, index, 'corporate_motorcycle') : [], '300px'),
        this.tableCellMapper(item.offerType
          ? Utils.toCapitalize(item.offerType).replace(' ', '-')
          : '', '180px'),
        this.tableCellMapper(this.setBadgeLabel(item.isActive), '140px'),
        this.tableCellMapper(item.updatedAt
          ? Utils.formatDateWithIDLocale(
              String(item.updatedAt),
              'dddd, DD MMM YYYY'
            )
          : '', '180px'),
        this.tableCellMapper(item.createdAt
          ? Utils.formatDateWithIDLocale(
              String(item.createdAt),
              'dddd, DD MMM YYYY'
            )
          : '', '180px'),
        this.tableCellMapper(String(item.areaId), '400px'),
      ]
    })
  }

  @Watch('controller.dataGeoAddressList')
  setGeoAddressData(data: IGeoAddress[]): void {
    this.geoAddressData = data
    this.fetchManageCourierDedicated()
  }

  @Watch('controller.isDeleteManageCourierDedicatedSuccess')
  onCheckDelete(data: boolean): void {
    this.deleteId = ''

    if (data) {
      this.$notify({
        title: 'Area Berhasil Dihapus',
        text: 'Area Dedicated Berhasil Dihapus',
        type: 'success',
        duration: 5000,
      })

      controller.setErrDelete('')
      controller.setIsDeleteManageCourierDedicatedSuccess(false)
      this.fetchManageCourierDedicated(true)
    }
  }
}

export default AreaDedicatedListPage;
